import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { NombrePilaVariacion } from './NombrePilaVariacion';
import { NombrePila } from '../NombresPila/NombrePila';
import ErrorDialog from '../utilities/ErrorDialog';

export interface INombrePilaVariacionEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: NombrePilaVariacion | undefined;
}

export interface INombrePilaVariacionEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    nombresPila: NombrePila[];
    openErroDialog: boolean;
}

export default class NombrePilaVariacionEdit extends React.Component<INombrePilaVariacionEditProps, INombrePilaVariacionEditState> {
    _nombrePilaVariacion: NombrePilaVariacion = new NombrePilaVariacion();
    _id: number = -1;
    
    public constructor(props: INombrePilaVariacionEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            nombresPila: [],
            openErroDialog: false
        }
    }

    componentDidMount(): void {
        this.GetNombresPila();
    }

    componentWillReceiveProps(nextProps: Readonly<INombrePilaVariacionEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._nombrePilaVariacion = nextProps.selectedItem;
            console.log(this._nombrePilaVariacion);
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Modificar nombre de pila
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <Autocomplete
                                    defaultValue={this._nombrePilaVariacion.nombrePila}
                                    options={this.GetAutocompleteOptions()}
                                    onChange={(event: any, newValue: string) => {
                                        this._nombrePilaVariacion.nombrePila = newValue;
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Nombre de pila" variant="standard"/>
                                    )}
                                />
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Nombre' defaultValue={this._nombrePilaVariacion.variacion} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._nombrePilaVariacion.variacion = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Update.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Update() {
        if(this._nombrePilaVariacion.variacion == '' || this._nombrePilaVariacion.nombrePila == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/nombrespilavariacion/${this._nombrePilaVariacion.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._nombrePilaVariacion),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._nombrePilaVariacion = new NombrePilaVariacion();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._nombrePilaVariacion = new NombrePilaVariacion();
        });
    }

    private GetNombresPila(): void {
        let url = `${Common.END_POINT}/masters/nombrespila`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    nombresPila: response
                }
            );
        })
    }

    private GetAutocompleteOptions() {
        const options: any[] = [];

        for(let i = 0; i < this.state.nombresPila.length; i++) {
            const nombrePila = this.state.nombresPila[i];
            options.push(
                nombrePila.nombre
            )
        }

        return options;
    }
}